import { instance } from ".";

//로그인
function loginUser(userData) {
  return instance.post("login/login.seize", userData);
}

export { loginUser };
